import ReportCoverConfigs from './report_covers';

const getReportCoverConfig = (template) => {
	if (!template) {
		return ReportCoverConfigs.default;
	}
	const templateName = template.replace('_report', '');
	return ReportCoverConfigs[templateName] || ReportCoverConfigs.default;
};

export { getReportCoverConfig };
